import { useTranslation } from 'react-i18next'

export const SummaryInfoHelp: React.FC = () => {
  const { t } = useTranslation()

  return (
    <span style={{ color: '#999' }}>
      {t('idea_list.summary_info.select_contributor_to_see_data')}
    </span>
  )
}
